import { readonly, ref, watch } from 'vue';
import { callTool } from '../api/client';
import { useAuthStore } from '../stores/auth';

const projects = ref(false);
let pending: Promise<void> | null = null;
let scope = '';
let generation = 0;
function currentScope(): string {
  const auth = useAuthStore();
  return auth.isAuthenticated && auth.tenantId ? JSON.stringify([auth.tenantId, auth.bearer]) : '';
}
export function loadPlatformFeatures(): Promise<void> {
  const next = currentScope();
  if (scope !== next) {
    scope = next;
    generation++;
    projects.value = false;
    pending = null;
  }
  if (!next) return Promise.resolve();
  const request = generation;
  return pending ??= callTool<{ projects?: boolean }>('platform_features', {})
    .then((r) => {
      if (typeof r.projects !== 'boolean') throw new Error('Unable to read platform capabilities.');
      if (request === generation && scope === currentScope()) projects.value = r.projects;
    })
    .catch((error) => {
      if (request === generation) { projects.value = false; pending = null; }
      throw error;
    });
}
export function usePlatformFeatures() {
  watch(currentScope, () => { void loadPlatformFeatures().catch(() => undefined); }, { immediate: true, flush: 'sync' });
  return { projectsEnabled: readonly(projects) };
}
